export enum PerformancePages {
  MY_CODE_PAGE = 'My Code',
  OFFER_REDEMPTION = 'Offer Redemption',
  REWARDS_PAGE = 'Rewards',
  OFFERS_PAGE = 'Offers',
}
